import { ClientSide } from "~/@types";
import { IExpertFields } from "~/@types/generated/contentful";

export type ExpertTypeBadgeProps = {
  type?: ClientSide<IExpertFields>["type"];
  className?: string;
};

export default function ExpertTypeBadge({
  type,
  className = "",
}: ExpertTypeBadgeProps) {
  if (type === "guest") {
    return (
      <span
        className={`meta lg:meta-large block w-fit rounded-[6px] bg-black p-2 text-white ${className}`}
      >
        guest author
      </span>
    );
  }

  if (type === "alumni" || !type) {
    return (
      <span
        className={`meta lg:meta-large block w-fit rounded-[6px] border border-black bg-white p-2 text-black ${className}`}
      >
        institute alumni
      </span>
    );
  }

  return null;
}
